let FBXLoader = require('three-fbxloader-offical');

export { FBXLoader };